import _toConsumableArray from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Indicator, IndicatorInput } from "../indicator/indicator";
export var VolumeProfileInput =
/*#__PURE__*/
function (_IndicatorInput) {
  _inherits(VolumeProfileInput, _IndicatorInput);

  function VolumeProfileInput() {
    _classCallCheck(this, VolumeProfileInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(VolumeProfileInput).apply(this, arguments));
  }

  return VolumeProfileInput;
}(IndicatorInput);
export var VolumeProfileOutput = function VolumeProfileOutput() {
  _classCallCheck(this, VolumeProfileOutput);
};
export function priceFallsBetweenBarRange(low, high, low1, high1) {
  return low <= low1 && high >= low1 || low1 <= low && high1 >= low;
}
export var VolumeProfile =
/*#__PURE__*/
function (_Indicator) {
  _inherits(VolumeProfile, _Indicator);

  function VolumeProfile(input) {
    var _this;

    _classCallCheck(this, VolumeProfile);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VolumeProfile).call(this, input));
    var highs = input.high;
    var lows = input.low;
    var closes = input.close;
    var opens = input.open;
    var volumes = input.volume;
    var bars = input.noOfBars;

    if (!(lows.length === highs.length && highs.length === closes.length && highs.length === volumes.length)) {
      throw new Error("Inputs(low,high, close, volumes) not of equal size");
    }

    _this.result = [];
    var max = Math.max.apply(Math, _toConsumableArray(highs).concat(_toConsumableArray(lows), _toConsumableArray(closes), _toConsumableArray(opens)));
    var min = Math.min.apply(Math, _toConsumableArray(highs).concat(_toConsumableArray(lows), _toConsumableArray(closes), _toConsumableArray(opens)));
    var barRange = (max - min) / bars;
    var lastEnd = min;

    for (var i = 0; i < bars; i++) {
      var rangeStart = lastEnd;
      var rangeEnd = rangeStart + barRange;
      lastEnd = rangeEnd;
      var bullishVolume = 0;
      var bearishVolume = 0;
      var totalVolume = 0;

      for (var priceBar = 0; priceBar < highs.length; priceBar++) {
        var priceBarStart = lows[priceBar];
        var priceBarEnd = highs[priceBar];
        var priceBarOpen = opens[priceBar];
        var priceBarClose = closes[priceBar];
        var priceBarVolume = volumes[priceBar];

        if (priceFallsBetweenBarRange(rangeStart, rangeEnd, priceBarStart, priceBarEnd)) {
          totalVolume = totalVolume + priceBarVolume;

          if (priceBarOpen > priceBarClose) {
            bearishVolume = bearishVolume + priceBarVolume;
          } else {
            bullishVolume = bullishVolume + priceBarVolume;
          }
        }
      }

      _this.result.push({
        rangeStart: rangeStart,
        rangeEnd: rangeEnd,
        bullishVolume: bullishVolume,
        bearishVolume: bearishVolume,
        totalVolume: totalVolume
      });
    }

    return _this;
  }

  _createClass(VolumeProfile, [{
    key: "nextValue",
    value: function nextValue(price) {
      throw new Error("Next value not supported for volume profile");
    }
  }]);

  return VolumeProfile;
}(Indicator);
VolumeProfile.calculate = volumeprofile;
export function volumeprofile(input) {
  Indicator.reverseInputs(input);
  var result = new VolumeProfile(input).result;

  if (input.reversedInput) {
    result.reverse();
  }

  Indicator.reverseInputs(input);
  return result;
}